import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthProvider';

export function NoAccessPage() {
  const { t } = useTranslation();
  const { signOut } = useAuth();
  return (
    <Result
      status="403"
      title={t('noAccess.title')}
      subTitle={t('noAccess.description')}
      extra={<Button onClick={() => void signOut()}>{t('app.signOut')}</Button>}
    />
  );
}
